import { Injectable, Output, EventEmitter } from '@angular/core';
export class Order {
  beforeTimer: any;
  createDate: any;
  deliveryId: any;
  discountPercent: any;
  discountValue: any;
  districtId: any;
  domain: any;
  fromSystemId: any;
  id: any;
  maBuuCuc: null;
  maDonViVanChuyen: null;
  maVanDon: any;
  orderAddress: any;
  orderMobile: any;
  orderName: any;
  orderNote: any;
  productName: any;
  provinceId: any;
  registerDate: any;
  remindDate: any;
  remindNote: any;
  tags: any;
  tenBuuCuc: any;
  wardId: any;
  worklistId: any;
}
@Injectable({
  providedIn: 'root',
})
export class PassService {
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() changeAssignee: EventEmitter<any> = new EventEmitter();
  @Output() changeInfo: EventEmitter<any> = new EventEmitter();

  @Output() changeInfoSearch: EventEmitter<any> = new EventEmitter();
  @Output() changeInfoBuyer: EventEmitter<any> = new EventEmitter();

  @Output() changeOrder: EventEmitter<any> = new EventEmitter();
  @Output() checkLoad: EventEmitter<boolean> = new EventEmitter();
  @Output() popupInfo: EventEmitter<any> = new EventEmitter();
  @Output() title: EventEmitter<string> = new EventEmitter();
  @Output() notiNumber: EventEmitter<number> = new EventEmitter();

  onHandleTitle(title) {
    this.title.emit(title);
  }
  openPopupInfo(selectedOrder) {
    this.popupInfo.emit(selectedOrder);
  }
  onSelectChange(selectedOrder) {
    this.change.emit(selectedOrder);
  }

  onChangeAssignee(selectedOrder) {
    this.changeAssignee.emit(selectedOrder);
  }

  onChangeInfo(infoNew) {
    this.changeInfo.emit(infoNew);
  }

  onChangeInfoSearch(infoNew) {
    this.changeInfoSearch.emit(infoNew);
  }

  onChangeInfoBuyer(infoNew) {
    this.changeInfoBuyer.emit(infoNew);
  }

  onChangeOrder(infoNew) {
    this.changeOrder.emit(infoNew);
  }
  onLoadOrder(check) {
    this.checkLoad.emit(check);
  }
  onChangeNotiNumber(notiNumber: number) {
    this.notiNumber.emit(notiNumber);
  }
}
